import { useEffect, useRef } from "react";

export const useHideTooltipByTimeout = ({ isShow, handleTooltipHide, timeout}) => {
    const previousShowRef = useRef(isShow);
    const timer = useRef(null);
    useEffect(() => {
        if (!previousShowRef.current && isShow && timeout) {
            timer.current = setTimeout(() => {
                handleTooltipHide();
            }, timeout)
        }
        previousShowRef.current = isShow;
        return () => {
            clearTimeout(timer.current)
        }
    }, [isShow, timeout, handleTooltipHide])
}